import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { getCategories } from '../../api';
import Reveal from './Reveal';

const ORDER = ['extintores', 'mangueiras', 'sinalizacao', 'iluminacao', 'galvanizados'];

const SPANS = {
  extintores: 'md:col-span-8 md:row-span-2',
  mangueiras: 'md:col-span-4',
  sinalizacao: 'md:col-span-4',
  iluminacao: 'md:col-span-6',
  galvanizados: 'md:col-span-6',
};

const BentoProducts = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getCategories()
      .then(setCategories)
      .catch(() => setCategories([]));
  }, []);

  const sorted = [...categories].sort(
    (a, b) => ORDER.indexOf(a.slug) - ORDER.indexOf(b.slug)
  );

  return (
    <section id="produtos" data-testid="products-section" className="relative py-28 bg-[#040D1A] overflow-hidden">
      <div className="absolute top-0 right-[-15%] w-[38rem] h-[38rem] spotlight-blue opacity-50 pointer-events-none" />
      <div className="container mx-auto px-4 relative z-10">
        <Reveal className="mb-14 md:flex items-end justify-between gap-8">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-300 mb-4">
              Catálogo
            </p>
            <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white">
              Nossos Produtos
            </h2>
          </div>
          <p className="text-slate-400 max-w-sm mt-4 md:mt-0 text-sm leading-relaxed">
            Equipamentos certificados para combate e prevenção de incêndios.
            Escolha uma linha para explorar.
          </p>
        </Reveal>

        <div
          data-testid="bento-grid"
          className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[250px] gap-5"
        >
          {sorted.map((cat, i) => (
            <Reveal
              key={cat.slug}
              delay={i * 0.08}
              className={`${SPANS[cat.slug] || 'md:col-span-4'} h-full`}
            >
              <button
                data-testid={`bento-category-${cat.slug}`}
                onClick={() => navigate(cat.route)}
                className="group relative w-full h-full min-h-[250px] rounded-2xl overflow-hidden border border-amber-400/10 text-left hover:border-amber-400/40 hover:shadow-[0_20px_60px_rgba(252,211,77,0.12)] hover:-translate-y-1 transition-all duration-500"
              >
                <img
                  src={cat.cover_image}
                  alt={cat.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#040D1A] via-[#040D1A]/45 to-[#040D1A]/10" />
                <span className="absolute top-5 left-6 font-mono text-xs tracking-[0.3em] text-amber-300/80">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="absolute bottom-0 inset-x-0 p-6 md:p-7">
                  <h3 className="font-display font-bold uppercase text-xl md:text-2xl text-white tracking-tight">
                    {cat.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-300/90 line-clamp-2 max-w-md">
                    {cat.description}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-300">
                    Explorar linha
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BentoProducts;
